module.exports = __webpack_public_path__ + "img/home_phone_banner1.35fed15d.png";